var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0"},[(_vm.isLoading)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{staticStyle:{"height":"250px"},attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"size":100,"width":5,"color":"primary","indeterminate":""}})],1)],1)],1):_c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-spacer'),_c('customer-detail-update-dialog',{attrs:{"customer":_vm.customer},on:{"action":_vm.onUpdate},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"rounded":"","outlined":"","color":"primary"}},on),[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(" edit ")]),_vm._v(" Update details ")],1)]}}])})],1),_c('v-divider',{})],1),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('span',{staticClass:"title"},[_vm._v("Account Information")]),_c('v-divider',{staticClass:"my-3"}),_c('info-list',{attrs:{"list":[
          {
            label: 'Name',
            value: _vm.customer.name
          },
          {
            label: 'Email',
            value: _vm.customer.email
          },
          {
            label: 'Phone',
            value: _vm.customer.phone
          },
          {
            label: 'Description',
            value: _vm.customer.description
          },
          {
            label: 'ID',
            value: _vm.customer.id
          },
          {
            label: 'Language',
            value: _vm.customer.preferred_locales ? _vm.customer.preferred_locales.join(', ') : ''
          },
          {
            label: 'Created',
            value: _vm._formatDate(_vm.customer.created)
          }

        ]}})],1),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('span',{staticClass:"title"},[_vm._v("Billing Information")]),_c('v-divider',{staticClass:"my-3"}),_c('info-list',{attrs:{"list":[
          {
            label: 'Invoice Prefix',
            value: _vm.get(_vm.customer, 'invoice_prefix', '')
          },
          {
            label: 'Tax Status',
            value: _vm.get(_vm.customer, 'tax_exempt', '')
          },
          {
            label: 'Billing Address',
            value: [
              ((_vm.get(_vm.customer, 'address.line1', '') || '') + " " + (_vm.get(_vm.customer, 'address.line2', '') || '')),
              ((_vm.get(_vm.customer, 'address.city', '') || '') + " " + (_vm.get(_vm.customer, 'address.state', '') || '') + " " + (_vm.get(_vm.customer, 'address.postal_code', '') || '')),
              (_vm.get(_vm.customer, 'address.country', '') || '')
            ]
          } ]}})],1),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('span',{staticClass:"title"},[_vm._v("Shipping Information")]),_c('v-divider',{staticClass:"my-3"}),_c('info-list',{attrs:{"list":[
          {
            label: 'Name',
            value: _vm.get(_vm.customer, 'shipping.name', '')
          },
          {
            label: 'Phone',
            value: _vm.get(_vm.customer, 'shipping.phone', '')
          },
          {
            label: 'Shipping Address',
            value: [
              ((_vm.get(_vm.customer, 'shipping.address.line1', '') || '') + " " + (_vm.get(_vm.customer, 'shipping.address.line2', '') || '')),
              ((_vm.get(_vm.customer, 'shipping.address.city', '') || '') + " " + (_vm.get(_vm.customer, 'shipping.address.state', '') || '') + " " + (_vm.get(_vm.customer, 'shipping.address.postal_code', '') || '')),
              (_vm.get(_vm.customer, 'shipping.address.country', '') || '')
            ]
          }
        ]}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }